import React from 'react'
import { DownloadInstruction } from 'components'

const DownloadInstructionPage = () => <DownloadInstruction />

export default DownloadInstructionPage
